import { Badge, Box } from "@chakra-ui/layout";
import { NavBar } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import { useGetProjectBudgetExceededCountQuery } from "@src/__generated__/graphql";
import { Icon } from "@src/components/ui-kit/Icon";
import { cannot } from "@src/utils/components/permissions";
import { useScreenType } from "@src/utils/hooks/useIsMobile";
import { observer } from "mobx-react-lite";
import type { LinkProps } from "next/link";
import { Fragment } from "react";
import { AppSubNav } from "../AppSubNav";

export type NavigationReportsProps = {
  currentReport?: {
    href: LinkProps["href"];
    title: () => string;
    isBeta?: boolean;
  };
};

const NavigationReports = ({ currentReport }: NavigationReportsProps) => {
  const { isDesktop } = useScreenType();
  const isBudgetExceeded = currentReport?.href === "/reports/budget-exceeded";
  const { data } = useGetProjectBudgetExceededCountQuery({
    fetchPolicy: "cache-and-network",
    skip: cannot("project_viewAllFields") || !isBudgetExceeded,
  });

  return (
    <AppSubNav>
      <NavBar.Item href="/reports" underline={false}>
        <Trans>Reports</Trans>
      </NavBar.Item>
      {currentReport && (
        <Fragment>
          {isDesktop && <Icon name="chevron-right" />}
          <NavBar.Item href={currentReport.href} underline={false}>
            {currentReport.title()}
            {isBudgetExceeded &&
              typeof data?.getActiveProjectBudgetExceededCount === "number" && (
                <Badge colorScheme="red" size="sm" ml="2">
                  {data.getActiveProjectBudgetExceededCount}
                </Badge>
              )}
            {currentReport.isBeta && (
              <Badge size="sm" ml="2">
                <Box as="span" fontSize="2xs" fontWeight="medium">
                  <Trans>BETA</Trans>
                </Box>
              </Badge>
            )}
          </NavBar.Item>
        </Fragment>
      )}
    </AppSubNav>
  );
};

export default observer(NavigationReports);
